import { createURL } from '@sm/utils';
import { t } from '@sm/intl';
import COPY from '../NavBarCopy';

export const getNavBarLOLinks = () => {
  const navBarLOLinks = [
    {
      name: t(COPY.PRODUCTS)
    },
    {
      name: t(COPY.SOLUTIONS)
    },
    {
      name: t(COPY.RESOURCES)
    },
    {
      path: createURL('https://help.surveymonkey.com/', {
        ut_source: 'megamenu'
      }),
      name: t(COPY.HELP_CENTER)
    },
    {
      path: createURL('/pricing/', { ut_source: 'megamenu' }),
      name: t(COPY.PLANS_AND_PRICING)
    }
  ];
  return navBarLOLinks;
};

export default getNavBarLOLinks;
